type IconProps = React.ComponentProps<'svg'>

export function DotsVerticalIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(10.25, 3.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.75 14c0.9665 0 1.75 0.7835 1.75 1.75 0 0.9665-0.7835 1.75-1.75 1.75-0.9665 0-1.75-0.7835-1.75-1.75 0-0.9665 0.7835-1.75 1.75-1.75z m0 1.5c-0.13807 0-0.25 0.11193-0.25 0.25 0 0.13807 0.11193 0.25 0.25 0.25 0.13807 0 0.25-0.11193 0.25-0.25 0-0.13807-0.11193-0.25-0.25-0.25z m0-8.5c0.9665 0 1.75 0.7835 1.75 1.75 0 0.9665-0.7835 1.75-1.75 1.75-0.9665 0-1.75-0.7835-1.75-1.75 0-0.9665 0.7835-1.75 1.75-1.75z m0 1.5c-0.13807 0-0.25 0.11193-0.25 0.25 0 0.13807 0.11193 0.25 0.25 0.25 0.13807 0 0.25-0.11193 0.25-0.25 0-0.13807-0.11193-0.25-0.25-0.25z m0-8.5c0.9665 0 1.75 0.7835 1.75 1.75 0 0.9665-0.7835 1.75-1.75 1.75-0.9665 0-1.75-0.7835-1.75-1.75 0-0.9665 0.7835-1.75 1.75-1.75z m0 1.5c-0.13807 0-0.25 0.11193-0.25 0.25 0 0.13807 0.11193 0.25 0.25 0.25 0.13807 0 0.25-0.11193 0.25-0.25 0-0.13807-0.11193-0.25-0.25-0.25z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
